// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonButton,
  IonButtons,
  IonCol,
  IonFooter,
  IonRow,
  IonToolbar,
} from "@ionic/react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSquarePlus } from '@fortawesome/free-solid-svg-icons'
import { useLocales } from "react-localized"
import { ScreenSizeConditional, SectionContainer } from "../lib"
import { useContextMenu } from "../lib"
import { BasePurchaseOrderPageProps, OrderProductEditor } from '../components'
import { OrderProductEditorAppendContextPanel } from '../components'
import { PurchaseOrder } from "../models"
import ProcurementSectionMenu from "./ProcurementSectionMenu"


const PurchaseOrderAddProductsToolbar: React.FC<{order: PurchaseOrder}> = ({
  order
}) => {
  const {gettext} = useLocales()
  const ctx = useContextMenu()
  return (
    <IonButton
      className="collapsible"
      disabled={ctx.isOpen()}
      onClick={() => {
        if (!ctx.isOpen()) {
          ctx.setContextMenu(OrderProductEditorAppendContextPanel, {order: order})
        }
      }}
      fill="clear"
    >
      <FontAwesomeIcon icon={faSquarePlus}/>
      <span>{gettext("Add product")}</span>
    </IonButton>
  )
}


const PurchaseOrderAddProducts: React.FC<
  BasePurchaseOrderPageProps
  & {onPrevious(): void
}> = ({
  onPrevious,
  onSubmit,
  order
}) => {
  const {gettext} = useLocales()
  return (
    <>
      <SectionContainer
        canGoBack={false}
        menuComponent={ProcurementSectionMenu}
        nopadding
        ready={true}
        title={gettext("Select products")}
        toolbarComponent={PurchaseOrderAddProductsToolbar}
        toolbarProps={{order: order}}
      >
        <OrderProductEditor editable order={order}>
          <ScreenSizeConditional full>
            <div style={{padding: "11px"}}>
              <IonButton onClick={() => onSubmit()}>
                {gettext("Review and Place Purchase Order")}
              </IonButton>
              <IonButton
                color="medium"
                fill="clear"
                onClick={() => onPrevious()}
              >
                {gettext("Back")}
              </IonButton>
            </div>
          </ScreenSizeConditional>
        </OrderProductEditor>
      </SectionContainer>
      <ScreenSizeConditional>
        <IonFooter>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton
                color="primary"
                fill="clear"
                onClick={() => onSubmit()}
              >
                {gettext("Finish: Review")}
              </IonButton>
            </IonButtons>
            <IonButtons slot="end">
              <IonButton
                color="medium"
                fill="clear"
                onClick={() => onPrevious()}
              >
                {gettext("Back")}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </ScreenSizeConditional>
    </>
  )
}

export default PurchaseOrderAddProducts